module.exports = __webpack_public_path__ + "img/size_1_0.8efe67ed.png";